export function DropdownChevron() {
  return (
    <i
      aria-hidden="true"
      className="h-[9px] w-[9px] shrink-0 -translate-y-0.5 rotate-45 border-b-[1.5px] border-r-[1.5px] border-subtle"
    />
  );
}
